import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CardWithAddress } from '@spartacus/checkout/base/components';
import { MaskModule } from '../../../../core/pipes/mask/mask.module';
import { AddressTypeIconComponent } from '../../checkout/base/components/checkout-delivery-address/address-type-icon/address-type-icon.component';

@Component({
  selector: 'address-card',
  standalone: true,
  imports: [CommonModule, MaskModule, AddressTypeIconComponent],
  templateUrl: './address-card.component.html',
  styleUrl: './address-card.component.scss',
})
export class AddressCardComponent {
  @Input() card!: CardWithAddress;
  @Input() containerClass = 'simple-card border';
  @Input() showAddressTypeIcon = true;

  ableToMask(phone: string, mask: string): boolean {
    let isAble = false;
    const hasLetterOrSymbols = /[a-zA-Z!@#$%^&*(),.?":{}|<>]/g;
    const clearNumber = phone.replace(/\D/g, '');

    if (hasLetterOrSymbols.test(phone)) {
      return false;
    }

    mask.split('|').forEach(maskChar => {
      const clearMask = maskChar.replace(/\D/g, '');
      isAble = isAble || clearMask.length === clearNumber.length;
    });

    return isAble;
  }
}
